import React from 'react';

import PageNotFound from '@components/lpc/404/PageNotFound/PageNotFound';
import PotNotFound from '@components/lpc/404/PotNotFound/PotNotFound';
import Layout from '@components/lpc/Layout/Layout';

type Custom404Props = {
    potNotFound?: boolean;
};

const Custom404 = ({ potNotFound }: Custom404Props) => {
    return (
        <>
            {potNotFound ? (
                <Layout>
                    <PotNotFound />
                </Layout>
            ) : (
                <PageNotFound />
            )}
        </>
    );
};

export default Custom404;
